<template>
  <div class="m-edition-map-chart-messages">
    <MoleculeEditionMapChartNodeHeader
      :is-node-item="false"
      :element="element"
    />
    <div class="m-edition-asset-content-comments">
      <div>
        <MoleculeEditionAssetContentCommentsCreate
          :comentarios-tipo="comentariosTipo"
          :comment="null"
          :contenido="contenido"
          :is-reply="false"
          class="margin-top-xlarge"
        />
        <div
          v-if="showLoadingState"
          key="loadingMessages"
        >
          <p class="font-size-small text-align-center">
            Cargado Mensajes...
          </p>
        </div>
        <div v-else-if="comentarios.length">
          <MoleculeEditionAssetContentCommentsReplies
            v-for="comentario in paginas[paginaActual]"
            :key="comentario.id"
            :comentarios-tipo="comentariosTipo"
            :comment="comentario"
            :contenido="contenido"
            :is-child="false"
          />
          <div
            v-if="paginas.length > 1"
            class="m-edition-map-chart-messages-pages"
          >
            <a
              v-for="(pagina, index) in paginas"
              :key="index"
              :class="[paginaActual === index ? 'page-active' : '', 'text-link-hover-academy']"
              href="#"
              @click.prevent="getPage(index)"
            >
              {{ index + 1 }}
            </a>
          </div>
        </div>
        <div
          v-else
          key="zeroMessages"
        >
          <p class="font-size-xsmall text-align-center">
            Aún no hay mensajes en {{ this.$store.getters.getSelectedMapNode.nombre }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapChartMessages',

  components: {
    MoleculeEditionAssetContentCommentsCreate: () => import('@/components/molecules/MoleculeEditionAssetContentCommentsCreate'),
    MoleculeEditionAssetContentCommentsReplies: () => import('@/components/molecules/MoleculeEditionAssetContentCommentsReplies'),
    MoleculeEditionMapChartNodeHeader: () => import('@/components/molecules/MoleculeEditionMapChartNodeHeader')
  },

  props: {
    element: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      comentarios: [],
      comentariosTipo: 3,
      showLoadingState: true,
      total: 0,
      totalPorPagina: 10,
      paginaActual: 0,
      paginas: [],
      uploadData: false
    }
  },

  computed: {
    contenido () {
      return Object.assign({}, this.$store.getters.getMapContents[0])
    },

    nodo () {
      return this.$store.getters.getSelectedMapNode
    },

    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    nodo () {
      this.resetPages()
      this.readContenidoComentarios()
    },

    updatedData () {
      this.resetPages()
      this.readContenidoComentarios()
    }
  },

  created () {
    this.readContenidoComentarios()
  },

  methods: {
    getPage (page) {
      this.paginaActual = page
    },

    readContenidoComentarios () {
      this.showLoadingState = true
      this.$services.read('contenido', 'readContenidoComentarios', {},
        [this.contenido.id, this.$store.getters.getSelectedMapNode.id],
        { tipo_comentario: this.comentariosTipo })
        .then(response => {
          this.comentarios = response.data
          this.total = this.comentarios.length
          if (this.total > 0) {
            this.setPages()
          }
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    },

    resetPages () {
      this.comentarios = []
      this.total = 0
      this.paginaActual = 0
      this.paginas = []
    },

    setPages () {
      let comments = [...this.comentarios]
      let cantPages = Math.ceil(this.total / this.totalPorPagina)
      for (let index = 0; index < cantPages; index++) {
        this.paginas[index] = comments.splice(0, 10)
      }
    }
  }
}
</script>
